import { useCurrentUser } from "@/react/contexts/punditUserContext";
import {
  ConnectionStatus,
  type ConnectionToCurrentCommunityMember,
} from "@/react/types/CommunityMember";

export const useDetermineConnectionStatus = (
  connection?: ConnectionToCurrentCommunityMember,
) => {
  const currentUser = useCurrentUser();

  const isDetachedOrWithdrawn =
    connection &&
    (connection.status === ConnectionStatus.DETACHED ||
      connection.status === ConnectionStatus.WITHDRAWN);

  const isIgnored =
    connection &&
    connection.status === ConnectionStatus.IGNORED &&
    connection.initiator.user_id === currentUser?.id;

  const isCurrentUserSentConnection =
    connection &&
    connection.status === ConnectionStatus.PENDING &&
    connection.initiator.user_id === currentUser?.id;

  const isOtherUserSentConnection =
    connection &&
    connection.status === ConnectionStatus.PENDING &&
    connection.initiator.user_id !== currentUser?.id;

  return {
    isEmpty: !connection || isDetachedOrWithdrawn || isIgnored,
    isActive: connection?.status === ConnectionStatus.ACTIVE,
    isCurrentUserSentConnection,
    isOtherUserSentConnection,
  };
};
